/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_First_Meeting_Title_PlaceholderInputs */



/**
* | output |
* | --- |
* | "E.g. 1:1 with Anne-Sophie" |
*
* @param {Onboarding_First_Meeting_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_first_meeting_title_placeholder = /** @type {((inputs?: Onboarding_First_Meeting_Title_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_First_Meeting_Title_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bv. 1:1 met Anne-Sophie")
	if (locale === "fr") return /** @type {LocalizedString} */ ("P. ex. 1:1 avec Anne-Sophie")
	return /** @type {LocalizedString} */ ("E.g. 1:1 with Anne-Sophie")
});